import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material'
import { ChevronDown20Regular } from '@/components/Icon'
import ToolPermissionRow from './ToolPermissionRow.jsx'
import styles from './toolPermissionsDialog.module.scss'

export default function ToolPermissionsGroup({ group, onChange }) {
  const counts = `${group.allowedCount} allowed, ${group.approvalCount} requires approval`
  return (
    <Accordion defaultExpanded disableGutters elevation={0} className={styles.group}>
      <AccordionSummary expandIcon={<ChevronDown20Regular aria-hidden />} className={styles.groupSummary}>
        <Box className={styles.groupHeading}><Typography className={styles.groupTitle}>{group.title}</Typography><Typography className={styles.groupCount}>{counts}</Typography></Box>
      </AccordionSummary>
      <AccordionDetails className={styles.groupDetails}>
        {group.tools.map((tool) => <ToolPermissionRow key={tool.slug} tool={tool} onChange={onChange} />)}
      </AccordionDetails>
    </Accordion>
  )
}
